export const parseExistingComments = (commentsString: string) => {
  if (!commentsString) return [];
  return commentsString
    .split('. ')
    .map((comment) => comment.trim())
    .filter((comment) => comment.length > 0);
};

export const parseExistingCommentsV2 = (commentsString: string): string[] => {
  if (!commentsString) return [];
  const trimmed = commentsString.trim().replace(/\.\s*$/, '');
  if (!trimmed) return [];
  return trimmed
    .split('. ')
    .map((comment) => comment.trim())
    .filter((comment) => comment.length > 0);
};
